import React, { useState, useEffect, useCallback } from "react";
import ItemsFichaTecnicaTabela from "./ItemsFichaTecnicaTabela";
import ItemsFichaTecnicaFormulario from "./ItemsFichaTecnicaFormulario";
import GradeFormulario from "./GradeFormulario";
import EncaixeManualDXF from "./EncaixeManualDXF";
import { Modal, Box, Button, Paper, Snackbar, Typography,CircularProgress } from "@mui/material";
import Grid from '@mui/material/Grid';
import { useParams, useNavigate } from 'react-router-dom';
import Select from "react-select";
import PermissionGate from "../CadastroPerfilUsuario/PermissionGate";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import URLManager from "../funcionalidadeNavbar/URLManager";
import LoadingSpinner from "../utils/LoadingSpinner";
import ConfirmationModal from "../components/ConfirmationModal";

const ItemsFichaTecnica = () => {
      // Estados para Encaixe Manual do modal de Grade
      const [quantidadeParesGrade, setQuantidadeParesGrade] = useState('');
      const [quantidadePecaGrade, setQuantidadePecaGrade] = useState('');
      const [espacamentoGrade, setEspacamentoGrade] = useState('');
      const [percentualPerdaGrade, setPercentualPerdaGrade] = useState('');
    // Estado para controle do número para encaixe manual
    const [numeroParaEncaixeManual, setNumeroParaEncaixeManual] = useState(null);
    const [componenteParaEncaixeManual, setComponenteParaEncaixeManual] = useState(null);
  // Estado para modal de grade
  const [openGradeModal, setOpenGradeModal] = useState(false);
  const [gradeNumeracao, setGradeNumeracao] = useState({});
  // Números da grade fixa (19..45) — usado por componentes que precisarem
  const numerosGrade = [
    "19","20","21","22","23","24","25","26","27","28","29",
    "30","31","32","33","34","35","36","37","38","39","40",
    "41","42","43","44","45"
  ];

  const [consultaNumero, setConsultaNumero] = useState('');
  const [consultaComponente, setConsultaComponente] = useState('');
  const [consultaTriggered, setConsultaTriggered] = useState(false);
  const [openConsultaModal, setOpenConsultaModal] = useState(false);

  const itemsFichaTecnica = {
    id: 0,
    idFichaTecnica: 0,
    estrutura: '',
    componentes: '',
    codigo: 0,
    unidade: '',
    tamanho: '',
    consumo: '',
    rendimento: '',
    custoPeca: '',
    equivalente: '',
    idMateriaPrima: 0,
    idProduto: 0,
    idEmpresa: 0,
    fornecedorInicial:'',
    tipoCalculo: 'metroLinear',
  quantidadePeca: 0,
  };
  const { idFichaTecnica, idProduto } = useParams();
  const _url = URLManager.getBaseURL();
  const [materiaPrimas, setMateriaPrimas] = useState([]);
  const [produtos, setProdutos] = useState([]);
  // const [componentePesquisado, setComponentePesquisado] = useState("");
  const [custoTotal, setCustoTotal] = useState([]);
  const [objItemsFicha, setObjItemsFicha] = useState(itemsFichaTecnica);
  const [ItemsFichaTecnicas, setItensFichaTecnicas] = useState([]);
  const [bntItemsFicha, setBtnItemsFicha] = useState(true);
  const [popperMessage, setPopperMessage] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // removed estruturaSelecionada - structure filter is no longer needed
  const [showEncaixeManual, setShowEncaixeManual] = useState(false);
  const [pecasDoDXF, setPecasDoDXF] = useState([]); // Armazena todas as peças do DXF carregado
  const [pecaSelecionadaIndex, setPecaSelecionadaIndex] = useState(0); // Índice da peça selecionada
  const [dxfMultiPecasFile, setDxfMultiPecasFile] = useState(null); // Arquivo DXF com múltiplas peças
  // eslint-disable-next-line no-unused-vars
  const [distanciaSeparacao, setDistanciaSeparacao] = useState(10); // Distância fixa para separar peças
  const [pecasOriginaisBackend, setPecasOriginaisBackend] = useState([]); // Guarda resposta original do backend
  const [loadingPython, setLoadingPython] = useState(false); // overlay de carregamento para serviços Python
  const [ultimoEncaixeCalculado, setUltimoEncaixeCalculado] = useState(null); // snapshot/contexto retornado no Calcular Consumo
  
  // Modal de confirmação
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: '',
    message: '',
    type: 'warning',
    onConfirm: null,
    confirmText: 'Confirmar',
    cancelText: 'Cancelar'
  });
  
  // Abrir tela de encaixe manual DXF (mantém o modal de Cadastrar Item aberto)

  const handleOpenEncaixeManual = () => {
    // Clear consumo so that opening the modal never pre-fills it
    setObjItemsFicha((prev) => ({ ...prev, consumo: '' }));
    setUltimoEncaixeCalculado(null);
    setShowEncaixeManual(true);
  };

  const handleCloseEncaixeManual = () => {
    setShowEncaixeManual(false);
    setNumeroParaEncaixeManual(null);
    setComponenteParaEncaixeManual(null);
  };

  // Função para re-processar a separação com nova distância
  // eslint-disable-next-line no-unused-vars
  const reprocessarSeparacao = () => {
    if (!pecasOriginaisBackend || pecasOriginaisBackend.length === 0) {
      mostrarMensagem('Nenhum arquivo DXF carregado');
      return;
    }

    console.log(`\n🔄 Reprocessando separação com distância: ${distanciaSeparacao}`);
    
    // Tenta primeiro separar por layer
    let pecasSeparadas = separarPecasPorLayer(pecasOriginaisBackend);
    
    // Se a separação por layer não funcionou, tenta por proximidade
    if (pecasSeparadas.length === pecasOriginaisBackend.length && 
        pecasOriginaisBackend.length === 1 && 
        pecasOriginaisBackend[0].entities && 
        pecasOriginaisBackend[0].entities.length > 5) {
      pecasSeparadas = separarPecasPorProximidade(pecasOriginaisBackend, distanciaSeparacao);
    }
    
    setPecasDoDXF(pecasSeparadas);
    setPecaSelecionadaIndex(0);
    mostrarMensagem(`Reprocessado: ${pecasSeparadas.length} peça(s) encontradas`);
  };


  // Função auxiliar para separar entidades por proximidade geométrica
  const separarPecasPorProximidade = (pecasRecebidas, distanciaMaxima = 100) => {
    console.log(`🔧 Separando peças por proximidade geométrica (distância máxima: ${distanciaMaxima})...`);
    const pecasSeparadas = [];
    
    pecasRecebidas.forEach((pecaOriginal, indexPeca) => {
      console.log(`\nAnalisando peça original ${indexPeca}:`, {
        nome: pecaOriginal.name || pecaOriginal.nome,
        entities: pecaOriginal.entities?.length || 0
      });
      
      if (!pecaOriginal.entities || pecaOriginal.entities.length === 0) {
        return;
      }

      // Se tem poucas entidades, considera como uma única peça
      if (pecaOriginal.entities.length <= 3) {
        console.log('  → Mantida como está (poucas entidades)');
        pecasSeparadas.push(pecaOriginal);
        return;
      }

      // Função para calcular o centro de uma entidade
      const getCentro = (entity) => {
        if (entity.points && entity.points.length > 0) {
          // Para POLYLINE, pega o centro do bounding box
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          entity.points.forEach(pt => {
            const x = Array.isArray(pt) ? pt[0] : pt.x;
            const y = Array.isArray(pt) ? pt[1] : pt.y;
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          });
          return { x: (minX + maxX) / 2, y: (minY + maxY) / 2 };
        }
        if (entity.center) {
          return { x: entity.center[0], y: entity.center[1] };
        }
        return { x: entity.x || 0, y: entity.y || 0 };
      };

      // Função para calcular distância entre dois centros
      const distancia = (centro1, centro2) => {
        const dx = centro1.x - centro2.x;
        const dy = centro1.y - centro2.y;
        return Math.sqrt(dx * dx + dy * dy);
      };

      // Clustering por proximidade (algoritmo DBSCAN simplificado)
      const DISTANCIA_MAXIMA = distanciaMaxima; // Usa o parâmetro passado
      const grupos = [];
      const visitados = new Set();

      pecaOriginal.entities.forEach((entity, idx) => {
        if (visitados.has(idx)) return;

        const grupo = [entity];
        visitados.add(idx);
        const centro = getCentro(entity);

        // Busca entidades próximas
        pecaOriginal.entities.forEach((outraEntity, outroIdx) => {
          if (visitados.has(outroIdx)) return;
          
          const outroCentro = getCentro(outraEntity);
          const dist = distancia(centro, outroCentro);

          if (dist <= DISTANCIA_MAXIMA) {
            grupo.push(outraEntity);
            visitados.add(outroIdx);
          }
        });

        if (grupo.length > 0) {
          grupos.push(grupo);
        }
      });

      console.log(`  → Encontrados ${grupos.length} grupos por proximidade`);

      // Cria uma peça para cada grupo
      grupos.forEach((grupo, idx) => {
        const novaPeca = {
          name: `Peça ${pecasSeparadas.length + 1}`,
          entities: grupo
        };
        console.log(`    • Grupo ${idx + 1}: ${grupo.length} entidades → "${novaPeca.name}"`);
        pecasSeparadas.push(novaPeca);
      });
    });

    console.log(`\n✅ Separação concluída: ${pecasRecebidas.length} → ${pecasSeparadas.length} peças\n`);
    return pecasSeparadas;
  };

  // Função auxiliar para separar entidades por layer (caso o backend não faça)
  const separarPecasPorLayer = (pecasRecebidas) => {
    console.log('🔧 Tentando separar peças por layer...');
    const pecasSeparadas = [];
    
    pecasRecebidas.forEach((pecaOriginal, indexPeca) => {
      console.log(`\nAnalisando peça original ${indexPeca}:`, {
        nome: pecaOriginal.name || pecaOriginal.nome,
        entities: pecaOriginal.entities?.length || 0
      });
      
      // Se a peça já tem poucas entidades, mantém como está
      if (!pecaOriginal.entities || pecaOriginal.entities.length <= 5) {
        console.log('  → Mantida como está (poucas entidades)');
        pecasSeparadas.push(pecaOriginal);
        return;
      }

      // Agrupa entidades por layer
      const entidadesPorLayer = {};
      pecaOriginal.entities.forEach(entity => {
        const layer = entity.layer || 'default';
        if (!entidadesPorLayer[layer]) {
          entidadesPorLayer[layer] = [];
        }
        entidadesPorLayer[layer].push(entity);
      });

      const layersEncontrados = Object.keys(entidadesPorLayer);
      console.log(`  → Encontrados ${layersEncontrados.length} layers:`, layersEncontrados);

      // Se só tem 1 layer, não adianta separar
      if (layersEncontrados.length === 1) {
        console.log('  → Apenas 1 layer encontrado, não será separado por layer');
        pecasSeparadas.push(pecaOriginal);
        return;
      }

      // Cria uma peça para cada layer
      Object.keys(entidadesPorLayer).forEach((layer, idx) => {
        const novaPeca = {
          name: layer === 'default' ? `Peça ${pecasSeparadas.length + 1}` : layer,
          entities: entidadesPorLayer[layer]
        };
        console.log(`    • Layer "${layer}": ${novaPeca.entities.length} entidades → "${novaPeca.name}"`);
        pecasSeparadas.push(novaPeca);
      });
    });

    console.log(`\n✅ Separação concluída: ${pecasRecebidas.length} → ${pecasSeparadas.length} peças\n`);
    return pecasSeparadas;
  };

  // Carregar DXF com múltiplas peças
  const handleCarregarDXFMultiplo = async () => {


    // SAFEGUARD: Prevent any accidental addition to the main items list/table
    // Reset the form state and close the modal to avoid any staged item
    setObjItemsFicha(itemsFichaTecnica);
    setOpenModal(false);

    if (!dxfMultiPecasFile) {
      mostrarMensagem('Selecione um arquivo DXF primeiro');
      return;
    }

    console.log('📤 Enviando DXF para processamento:');
    console.log('  - Nome:', dxfMultiPecasFile.name);
    console.log('  - Tamanho:', dxfMultiPecasFile.size, 'bytes');
    console.log('  - Tipo MIME:', dxfMultiPecasFile.type);

    const formData = new FormData();
    formData.append('file', dxfMultiPecasFile);

    // ✅ Usar backend Java
    const JAVA_API_URL = URLManager.getBaseURL();

    try {
      // Mostrar overlay enquanto o backend processa
      setLoadingPython(true);
      
      // Tenta primeiro endpoint de preview (apenas extrai, não cadastra)
      let previewUrl = `${JAVA_API_URL}/api/dxf/preview`;
      console.log(`  - Tentando URL preview: ${previewUrl}`);

      let response = await fetch(previewUrl, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
        body: formData,
      });

      // Se preview não existir (404), usa processar com params completos
      if (response.status === 404) {
        console.log('  - Preview não disponível, usando /processar');
        
        // Adiciona parâmetros obrigatórios para processar
        formData.append('quantidadePares', '0');
        formData.append('quantidadePeca', '0');
        formData.append('espacamento', '0');
        formData.append('larguraMaterial', '1000');
        formData.append('alturaMaterial', '500');
        formData.append('idFichaTecnica', idFichaTecnica || '0');
        formData.append('estrutura', 'PREVIEW');
        formData.append('componentes', 'PREVIEW');
        formData.append('tamanho', 'PREVIEW');
        formData.append('idMateriaPrima', '0');
        formData.append('tipoCalculo', 'metroLinear');
        formData.append('percentualPerda', '0');

        console.log(`  - URL processar: ${JAVA_API_URL}/api/dxf/processar`);
        response = await fetch(`${JAVA_API_URL}/api/dxf/processar`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          },
          body: formData,
        });
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Erro do servidor:', response.status, errorText);
        throw new Error(`Erro ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      console.log('📥 Resposta completa do backend:', data);
      
      // ✅ Tratamento de erro do backend
      if (data.status === 'error') {
        throw new Error(data.message || 'Erro no processamento do DXF');
      }

      // ✅ Tratamento de warning (extração parcial)
      if (data.warning) {
        console.warn('⚠️ Aviso do backend:', data.warning);
        mostrarMensagem(`Atenção: ${data.warning}`);
      }

      // ✅ Extrair item e peças do novo formato
      const item = data.item || data;
      const pecasRaw = Array.isArray(data.pecas) ? data.pecas : [];
      
      console.log('📦 Item processado:', item);
      console.log('📦 Peças brutas recebidas:', pecasRaw.length);
      
      // ✅ Normalizar e validar cada peça
      const normalizarPeca = (p, idx) => {
        const nome = (p && typeof p.nome === 'string' && p.nome.trim()) 
          ? p.nome 
          : (p && typeof p.name === 'string' && p.name.trim())
            ? p.name
            : `Peca ${idx + 1}`;
        
        const entities = Array.isArray(p.entities) 
          ? p.entities.filter(e =>
              e && 
              e.type === 'POLYLINE' && 
              Array.isArray(e.points) && 
              e.points.length >= 2
            )
          : [];
        
        return { name: nome, nome, entities };
      };

      // ✅ Filtrar peças válidas (com pelo menos uma entidade)
      let pecas = pecasRaw
        .map(normalizarPeca)
        .filter(p => p.entities.length > 0);
      
      if (!pecas.length) {
        console.warn('⚠️ Nenhuma peça válida encontrada após normalização');
        console.warn('Resposta original:', JSON.stringify(data, null, 2).substring(0, 500));
      }

      console.log('===== ✅ RESPOSTA DO BACKEND (processar via Python) =====');
      console.log('Peças válidas:', pecas.length);
      if (pecas.length > 0) {
        console.log('Primeira peça:', {
          nome: pecas[0].name || pecas[0].nome,
          quantidadeEntities: pecas[0].entities.length,
          primeiraEntity: {
            type: pecas[0].entities[0]?.type,
            quantidadePontos: pecas[0].entities[0]?.points?.length
          }
        });
        console.log('Amostra de pontos:', pecas[0].entities[0]?.points?.slice(0, 3));
      }
      
      // ✅ Validar se há peças
      if (pecas.length === 0) {
        console.error('⚠️ Backend não retornou peças válidas!');
        console.error('Arquivo DXF:', dxfMultiPecasFile.name);
        console.error('Tamanho:', dxfMultiPecasFile.size, 'bytes');
        
        throw new Error(
          `Backend não conseguiu extrair peças do DXF.\n\n` +
          `Possíveis causas:\n` +
          `• DXF sem entidades fechadas (CIRCLE, POLYLINE fechada, ELLIPSE)\n` +
          `• DXF de versão não suportada (use R12/R14)\n` +
          `• Geometrias em layers ocultos\n\n` +
          `💡 Tente:\n` +
          `1. Salvar como DXF R12 ou R14 (ASCII)\n` +
          `2. Verificar se há geometrias visíveis no CAD\n` +
          `3. Re-exportar com opção "Explode blocks"`
        );
      }
      
      // ✅ Validar estrutura de cada peça
      console.log('===== 📦 DETALHES DAS PEÇAS =====');
      pecas.forEach((peca, index) => {
        const nomeSeguro = peca.name || peca.nome || `Peça ${index + 1}`;
        console.log(`\nPeça ${index + 1}/${pecas.length}:`);
        console.log('  Nome:', nomeSeguro);
        console.log('  Entidades:', peca.entities?.length || 0);
        
        if (peca.entities && peca.entities.length > 0) {
          const tiposEntidades = [...new Set(peca.entities.map(e => e.type || 'UNKNOWN'))];
          console.log('  Tipos:', tiposEntidades.join(', '));
          
          const totalPontos = peca.entities.reduce((sum, e) => sum + (e.points?.length || 0), 0);
          console.log('  Total de pontos:', totalPontos);
          
          console.log('  Exemplo primeira entidade:', {
            type: peca.entities[0].type,
            pontos: peca.entities[0].points?.length,
            primeiros3: peca.entities[0].points?.slice(0, 3)
          });
        } else {
          console.warn('  ⚠️ Peça SEM entidades!');
        }
      });
      console.log('=====================================\n');
      
      // Guarda a resposta original do backend
      setPecasOriginaisBackend(pecas);
      
      // ✅ Ordenar peças por complexidade (mais pontos primeiro) - opcional
      pecas.sort((a, b) => {
        const pontosA = a.entities.reduce((sum, e) => sum + (e.points?.length || 0), 0);
        const pontosB = b.entities.reduce((sum, e) => sum + (e.points?.length || 0), 0);
        return pontosB - pontosA;
      });
      
      setPecasDoDXF(pecas);
      mostrarMensagem(`✅ ${pecas.length} peça(s) carregada(s) do DXF`);
      console.log('✅ Peças carregadas e ordenadas:', pecas.length);
      
    } catch (error) {
      console.error('❌ ERRO ao carregar DXF:', error);
      
      // Mensagem amigável para o usuário
      let mensagemUsuario = '❌ Erro ao processar arquivo DXF';
      
      if (error.message) {
        // Se já tem mensagem formatada, usar ela
        if (error.message.includes('Backend não conseguiu extrair')) {
          mensagemUsuario = error.message;
        } else if (error.message.includes('Erro 500') || error.message.includes('Erro 400')) {
          const apiUrl = JAVA_API_URL;
          mensagemUsuario = `Erro no servidor (${error.message.substring(0, 50)})\n\nVerifique se o backend está disponível em ${apiUrl}`;
        } else if (error.message.includes('Failed to fetch')) {
          mensagemUsuario = 'Não foi possível conectar ao servidor. O serviço pode estar acordando. Tente novamente em alguns segundos.';
        } else {
          mensagemUsuario = `Erro: ${error.message}`;
        }
      }
      
      alert(mensagemUsuario);
      mostrarMensagem('Falha ao carregar DXF');
    } finally {
      setLoadingPython(false);
    }
  };

  const [componentes, setComponentes] = useState("");
  const [itemsFichaTecnicaFiltra, setItemsFichaTecnicaFiltra] = useState(ItemsFichaTecnicas);
  const navigate = useNavigate();
  const [produtoInfo, setProdutoInfo] = useState(null);
  const [variacoes, setVariacoes] = useState([]);
  const [lastKnownParent, setLastKnownParent] = useState(null);
  const [openVariacaoModal, setOpenVariacaoModal] = useState(false);
  const [novaCorNome, setNovaCorNome] = useState('');
  const [novaCorImage, setNovaCorImage] = useState(null);
  const [creatingVariacao, setCreatingVariacao] = useState(false);
  const [novaCorPreview, setNovaCorPreview] = useState(null);
  const [imageTooLarge, setImageTooLarge] = useState(false);
  const [openEditarVariacaoModal, setOpenEditarVariacaoModal] = useState(false);
  const [editingVariacao, setEditingVariacao] = useState(false);
  const [editarNomeModelo, setEditarNomeModelo] = useState('');
  const [editarCor, setEditarCor] = useState('');
  const [editarMarca, setEditarMarca] = useState('');
  const [editarReferencia, setEditarReferencia] = useState('');
  const [editarImageFile, setEditarImageFile] = useState(null);
  const [editarPreview, setEditarPreview] = useState(null);
  const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
  const [selectedItems, setSelectedItems] = useState([]);

  const filtrarComponentes = (componentes) => {
    if (!componentes) {
      setItemsFichaTecnicaFiltra(ItemsFichaTecnicas);
    } else {
      const resultado = ItemsFichaTecnicas.filter((obj) =>
        obj.componentes.toLowerCase().includes(componentes.toLowerCase())
      );
      setItemsFichaTecnicaFiltra(resultado);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id)
        ? prev.filter((currentId) => currentId !== id)
        : [...prev, id]
    );
  };

  // Função para voltar à tela de Produto
  const voltarParaProduto = () => {
    navigate("../dashboard"); // Navega para a rota de Produto
  };

  const carregarDadosProduto = useCallback(async () => {
    try {
      const response = await fetch(`${_url}/produto/${idProduto}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
        },
      });

      if (!response.ok) {
        throw new Error(`Erro ao buscar dados do produto: ${response.statusText}`);
      }

      const produto = await response.json();
      setProdutoInfo(produto);
    } catch (error) {
      console.error("Erro ao carregar dados do produto:", error);
      mostrarMensagem("Erro ao carregar informações do produto");
    }
  }, [idProduto, _url]);
  // fetchFichaByProduto: busca fichas técnicas associadas a um produto
  const fetchFichaByProduto = useCallback(async (produtoId) => {
    try {
      const resp = await fetch(`${_url}/fichaTecnica/produto/${produtoId}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
      if (!resp.ok) return null;
      const json = await resp.json();
      if (Array.isArray(json)) return json.map(f => f.idFichaTecnica || f.id || f.idFicha || null).filter(Boolean);
      if (json && (json.idFichaTecnica || json.id)) return [json.idFichaTecnica || json.id];
      return null;
    } catch (e) {
      return null;
    }
  }, [_url]);


  const handleBuscar = async () => {
    try {
      setLoading(true);

      // Resolve ficha do produto primeiro; se não existir, usa a ficha da rota
      const fichas = await fetchFichaByProduto(idProduto);
      const fichaToUse = (Array.isArray(fichas) && fichas.length) ? fichas[0] : idFichaTecnica;

      const response = await fetch(`${_url}/items-ficha-tecnica/${fichaToUse}/${idProduto}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
      });

      if (!response.ok) {
        throw new Error('Erro na requisição: ' + response.statusText);
      }

      const data = await response.json();
      setCustoTotal(data.custoTotal || 0);

      if (data.itemsFichaTecnicas && Array.isArray(data.itemsFichaTecnicas)) {
        setItensFichaTecnicas(data.itemsFichaTecnicas);

        // Filtra por componentes após a estrutura ser atualizada
        if (componentes) {
          const resultado = data.itemsFichaTecnicas.filter((obj) =>
            obj.componentes.toLowerCase().includes(componentes.toLowerCase())
          );
          setItemsFichaTecnicaFiltra(resultado);
        } else {
          setItemsFichaTecnicaFiltra(data.itemsFichaTecnicas);
        }
      } else {
        setItensFichaTecnicas([]);
        setItemsFichaTecnicaFiltra([]);
      }
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
      mostrarMensagem('Estrutura inexistente');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    limparFicha();
    setOpenModal(false);
  };

  const mostrarMensagem = (mensagem) => {
    setPopperMessage(mensagem);
    setSnackbarOpen(true);
    setTimeout(() => setSnackbarOpen(false), 3000);
  };

  // Função para atualizar a descrição quando o usuário selecionar uma opção
  const handleSelectChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
  setComponentes(value);
  // Aplicar filtro localmente imediatamente para listar apenas o que foi pesquisado
  filtrarComponentes(value);
  console.log("Componente selecionado:", value); // Verifique no console
  };

  const options = Array.from(
    new Set(ItemsFichaTecnicas.map((obj) => obj.componentes))
  ).map((componentes) => ({
    value: componentes,
    label: componentes,

  }));



  const handleOpenModal = () => {
    limparFicha();

    setOpenModal(true);
  };

  // const [mostrarFormularioFicha,setmostrarFormularioFicha] = useState(false);

  useEffect(() => {
    if (!idProduto) return;

    (async () => {
      try {
        // Resolve a ficha que deve ser usada para este produto (prioriza ficha do produto)
        const fichas = await fetchFichaByProduto(idProduto);
        const fichaToUse = (Array.isArray(fichas) && fichas.length) ? fichas[0] : idFichaTecnica;

        // Busca os itens usando a ficha correta
        const resp = await fetch(`${_url}/items-ficha-tecnica/${fichaToUse}/${idProduto}`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
          },
        });

        if (resp.ok) {
          const json = await resp.json();
          console.log('Items carregados:', json);
          setObjItemsFicha(json);
          setItensFichaTecnicas(json.itemsFichaTecnicas || []);
          setItemsFichaTecnicaFiltra(json.itemsFichaTecnicas || []);
          setCustoTotal(json.custoTotal || 0);
        } else {
          setObjItemsFicha({});
          setItensFichaTecnicas([]);
          setItemsFichaTecnicaFiltra([]);
          setCustoTotal(0);
        }
      } catch (err) {
        console.error('Erro ao carregar ficha/items:', err);
        mostrarMensagem('Erro ao carregar informações do produto');
      }
    })();

  }, [idFichaTecnica, idProduto, _url, fetchFichaByProduto]);

  const recarregarItemsFicha = useCallback(async () => {
    try {
      setLoading(true);
      const fichas = await fetchFichaByProduto(idProduto);
      const fichaToUse = (Array.isArray(fichas) && fichas.length) ? fichas[0] : idFichaTecnica;

      const response = await fetch(`${_url}/items-ficha-tecnica/${fichaToUse}/${idProduto}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
        },
      });
      if (!response.ok) {
        throw new Error(`Erro ao buscar dados: ${response.statusText}`);
      }

      const data = await response.json();
      setItensFichaTecnicas(data.itemsFichaTecnicas || []);
      setItemsFichaTecnicaFiltra(data.itemsFichaTecnicas || []);
      setCustoTotal(data.custoTotal || 0);
      
    } catch (error) {
      console.error("Erro ao carregar itens da ficha técnica:", error);
    } finally {
      setLoading(false);
    }
  }, [idFichaTecnica, idProduto, _url, fetchFichaByProduto]);




  const carregarMateriaPrimas = useCallback(() => {
    fetch(`${_url}/materiaPrima/listar`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((response) => response.json())
      .then((dadosMateriaPrimas) => setMateriaPrimas(dadosMateriaPrimas))
      .catch((error) => console.error('Erro ao carregar matéria-prima:', error));
  }, [_url]);

  const carregarProduto = useCallback(() => {
    fetch(`${_url}/produto/so-pais`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
      .then((response) => response.json())
      .then((dadosProdutos) => setProdutos(dadosProdutos))
      .catch((error) => console.error('Erro ao carregar produtos:', error));
  }, [_url]);

  const aoDigitar = (e) => {
    // CÓDIGO COMENTADO - Tratamento de arquivo DXF removido
    // Agora apenas tratamos campos de texto normalmente
    /* if (e.target.name === 'dxfFile') {
      setObjItemsFicha({ ...objItemsFicha, [e.target.name]: e.target.files[0] });
    } else { */
      setObjItemsFicha({ ...objItemsFicha, [e.target.name]: e.target.value });
    /* } */
  };

  // FUNÇÃO COMENTADA - handleCadastrar com verificação de DXF
  // Agora cadastramos diretamente sem arquivo DXF
  const handleCadastrar = () => {
    /* if (objItemsFicha.dxfFile) {
      cadastrarComDXF();
    } else { */
      cadastrarItemsFichaTecnica();
    /* } */
  };

  const gerarPdfEncaixe = ({ itemData, fichaToUse }) => {
    const snapshotPng = ultimoEncaixeCalculado?.encaixeSnapshotPng;
    if (!snapshotPng) {
      return false;
    }

    const popup = window.open('', '_blank', 'width=980,height=760');
    if (!popup) {
      return false;
    }

    // Buscar nome do produto
    let nomeProduto = idProduto;
    if (produtoInfo && produtoInfo.descricao) {
      nomeProduto = produtoInfo.descricao;
    } else if (produtoInfo && produtoInfo.nome) {
      nomeProduto = produtoInfo.nome;
    } else if (produtoInfo && produtoInfo.referencia) {
      nomeProduto = produtoInfo.referencia;
    }

    // Buscar nome da matéria-prima
    let nomeMateriaPrima = itemData?.idMateriaPrima || '-';
    if (itemData?.idMateriaPrima && materiaPrimas && Array.isArray(materiaPrimas)) {
      const materia = materiaPrimas.find(m => String(m.id) === String(itemData.idMateriaPrima));
      if (materia && materia.descricao) {
        nomeMateriaPrima = materia.descricao;
      } else if (materia && materia.nome) {
        nomeMateriaPrima = materia.nome;
      }
    }

    const metaRows = [
      ['Ficha Tecnica', fichaToUse],
      ['Produto', nomeProduto],
      ['Estrutura', itemData?.estrutura || '-'],
      ['Componente', itemData?.componentes || '-'],
      ['Tamanho', itemData?.tamanho || '-'],
      ['Materia-prima', nomeMateriaPrima],
      ['Consumo', itemData?.consumo || '-'],
      ['Numero Grade', ultimoEncaixeCalculado?.numeroGrade || '-'],
      ['Componente Encaixe', ultimoEncaixeCalculado?.componente || '-'],
      ['Gerado em', new Date().toLocaleString()]
    ];

    const tableHtml = metaRows
      .map(([k, v]) => `<tr><td><strong>${k}</strong></td><td>${String(v)}</td></tr>`)
      .join('');

    const componenteEncaixeRaw =
      ultimoEncaixeCalculado?.componente ||
      itemData?.componentes ||
      componenteParaEncaixeManual ||
      objItemsFicha?.componentes ||
      'SEM_COMPONENTE';
    const componenteEncaixe = String(componenteEncaixeRaw)
      .trim()
      .replace(/[\\/:*?"<>|]/g, '-')
      .replace(/\s+/g, ' ');
    const documentTitle = `Relatorio Encaixe - ${componenteEncaixe}`;

    popup.document.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>${documentTitle}</title>
          <style>
            @page { size: A4 landscape; margin: 8mm; }
            * { box-sizing: border-box; }
            body { 
              font-family: Arial, sans-serif; 
              color: #222; 
              margin: 0; 
              padding: 0;
            }
            h1 { 
              font-size: 14px; 
              margin: 0 0 8px 0; 
              font-weight: bold;
            }
            .container {
              display: flex;
              gap: 10px;
              align-items: flex-start;
            }
            .meta { 
              flex: 0 0 280px;
              min-width: 280px;
            }
            table { 
              border-collapse: collapse; 
              width: 100%; 
              font-size: 9px;
            }
            td { 
              border: 1px solid #ccc; 
              padding: 3px 5px; 
              vertical-align: top; 
            }
            td:first-child {
              width: 40%;
              background: #f5f5f5;
            }
            .snapshot-wrap { 
              flex: 1;
              border: 1px solid #ddd; 
              padding: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
              max-height: 520px;
              overflow: hidden;
            }
            .snapshot-wrap img { 
              max-width: 100%;
              max-height: 510px;
              height: auto;
              width: auto;
              display: block;
              object-fit: contain;
            }
            .hint { 
              margin-top: 5px; 
              font-size: 9px; 
              color: #666;
              text-align: center;
            }
            @media print {
              .container {
                page-break-inside: avoid;
              }
              .snapshot-wrap img {
                max-height: 510px;
              }
            }
          </style>
        </head>
        <body>
          <h1>Relatorio do Encaixe Manual</h1>
          <div class="container">
            <div class="meta">
              <table><tbody>${tableHtml}</tbody></table>
            </div>
            <div class="snapshot-wrap">
              <img src="${snapshotPng}" alt="Snapshot do encaixe" />
            </div>
          </div>
          <div class="hint">No dialogo de impressao, escolha destino "Salvar como PDF".</div>
        </body>
      </html>
    `);
    popup.document.close();
    popup.focus();

    setTimeout(() => {
      popup.print();
    }, 250);

    return true;
  };

  const cadastrarItemsFichaTecnica = async () => {
    // Nenhum campo obrigatório no front-end

    try {
      // resolve ficha antes de enviar
      const fichas = await fetchFichaByProduto(idProduto);
      const fichaToUse = (Array.isArray(fichas) && fichas.length) ? fichas[0] : idFichaTecnica;

      const itemData = {
        ...objItemsFicha,
        idFichaTecnica: fichaToUse,
        idProduto: idProduto,
      };

      const resp = await fetch(`${_url}/items-ficha-tecnica/manual/${fichaToUse}`, {
        method: 'POST',
        body: JSON.stringify(itemData),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
      });

      if (!resp.ok) {
        const text = await resp.text();
        throw new Error(text || 'Falha ao cadastrar o item.');
      }

      await resp.json();
      const pdfGerado = gerarPdfEncaixe({ itemData, fichaToUse });
      mostrarMensagem(pdfGerado
        ? 'Item cadastrado com sucesso! Relatorio do encaixe pronto para salvar em PDF.'
        : 'Item cadastrado com sucesso!');
      recarregarItemsFicha();
      limparFicha();
      handleCloseModal();
    } catch (error) {
      console.error('Erro ao cadastrar o item:', error);
      mostrarMensagem(`Erro: ${error.message}`);
    }
  };

  // FUNÇÃO COMENTADA - Cadastro com arquivo DXF
  // Esta função foi desativada pois agora utilizamos apenas o Encaixe Manual DXF
  /*
  const cadastrarComDXF = () => {
    // Nenhuma validação obrigatória no front-end; backend deve tratar consistência

    const formData = new FormData();
    formData.append('file', objItemsFicha.dxfFile);
    formData.append('quantidadePares', objItemsFicha.quantidadePares || 0);
  formData.append('quantidadePeca', objItemsFicha.quantidadePeca || 0);
    formData.append('espacamento', objItemsFicha.espacamento || 0);
    formData.append('larguraMaterial', objItemsFicha.larguraMaterial || 0);
    formData.append('alturaMaterial', objItemsFicha.alturaMaterial || 0);
    formData.append('idFichaTecnica', idFichaTecnica);
    formData.append('estrutura', objItemsFicha.estrutura);
    formData.append('componentes', objItemsFicha.componentes);
    formData.append('tamanho', objItemsFicha.tamanho);
    formData.append('idMateriaPrima', objItemsFicha.idMateriaPrima);
    formData.append('tipoCalculo', objItemsFicha.tipoCalculo);
  formData.append('percentualPerda', objItemsFicha.percentualPerda || 0);


    fetch(`${_url}/api/dxf/processar`, { // Endpoint do backend para processar DXF
      method: 'POST',
      body: formData,
      headers: {
        // Não defina 'Content-Type'. O navegador fará isso automaticamente para multipart/form-data
        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
    })
    .then(async response => {
      if (!response.ok) {
        const errorText = await response.text();
        try {
          // Try to parse the error response as JSON
          const errorJson = JSON.parse(errorText);
          throw new Error(errorJson.message || 'Falha ao processar o arquivo DXF.');
        } catch (e) {
          // If it's not JSON, use the raw text
          throw new Error(errorText || 'Falha ao processar o arquivo DXF.');
        }
      }
      return response.json(); // The backend should return the created item as JSON
    })
    .then(data => {
      mostrarMensagem('Item cadastrado com sucesso com base no arquivo DXF!');
      recarregarItemsFicha();
      limparFicha();
      handleCloseModal();
    })
    .catch(error => {
      console.error('Erro ao cadastrar com DXF:', error);
      mostrarMensagem(`Erro: ${error.message}`);
      limparFicha(); // Limpa o formulário em caso de erro
    });
  };
  */

  // Alterar item DXF
  const alterarItemsFicha = async () => {
  if (!objItemsFicha.id) {
    mostrarMensagem('Selecione um item para alterar.');
    return;
  }
  
  try {
    // 1. Alterar no DXF
    const dxfRequestDTO = {
      componentes: objItemsFicha.componentes,
      estrutura: objItemsFicha.estrutura,
      tamanho: objItemsFicha.tamanho,
      idMateriaPrima: objItemsFicha.idMateriaPrima,
      tipoCalculo: objItemsFicha.tipoCalculo,
      espacamento: objItemsFicha.espacamento || 0
    };
    
    const responseDxf = await fetch(`${_url}/api/dxf/alterar/${objItemsFicha.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
      body: JSON.stringify(dxfRequestDTO)
    });
    
    if (!responseDxf.ok) {
      throw new Error('Falha ao alterar o item DXF');
    }
    
    // 2. Alterar no ItemsFichaTecnica - ✅ CORREÇÃO AQUI
    // Use objItemsFicha.id em vez de objItemsFicha.idProduto
    const itemsFichaTecnicaDTO = {
      id: objItemsFicha.id,
      idMateriaPrima: objItemsFicha.idMateriaPrima,
      estrutura: objItemsFicha.estrutura,
      componentes: objItemsFicha.componentes,
      tamanho: objItemsFicha.tamanho,
      consumo: objItemsFicha.consumo,
      unidade: objItemsFicha.tipoCalculo,
      rendimento: objItemsFicha.rendimento,
      custoPeca: objItemsFicha.custoPeca === undefined || objItemsFicha.custoPeca === null || objItemsFicha.custoPeca === '' ? 0 : Number(objItemsFicha.custoPeca),
      quantidadePeca: objItemsFicha.quantidadePeca || 0,
      equivalente: objItemsFicha.equivalente,
      idFornecedor: objItemsFicha.idFornecedor,
      ordem: objItemsFicha.ordem
    };
    
    // ✅ Use objItemsFicha.id (o ID do item) em vez de objItemsFicha.idProduto
    const responseItems = await fetch(`${_url}/items-ficha-tecnica/alterar/${objItemsFicha.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem("usuarioToken")}`
      },
      body: JSON.stringify(itemsFichaTecnicaDTO)
    });
    
    if (!responseItems.ok) {
      const errorText = await responseItems.text();
      throw new Error(errorText || 'Falha ao alterar o item padrão');
    }

    const fichas = await fetchFichaByProduto(idProduto);
    const fichaToUse = (Array.isArray(fichas) && fichas.length) ? fichas[0] : idFichaTecnica;
    const itemDataPdf = {
      ...objItemsFicha,
      idFichaTecnica: fichaToUse,
      idProduto: idProduto,
      unidade: objItemsFicha.tipoCalculo
    };
    const pdfGerado = gerarPdfEncaixe({ itemData: itemDataPdf, fichaToUse });

    mostrarMensagem(pdfGerado
      ? 'Item alterado com sucesso! Relatorio do encaixe pronto para salvar em PDF.'
      : 'Item alterado com sucesso!');
    recarregarItemsFicha();
    limparFicha();
    handleCloseModal();
    
  } catch (error) {
    mostrarMensagem(`Erro: ${error.message}`);
  }
};

   // Deletar item DXF
   const remover = async () => {
    if (selectedItems.length === 0) {
      mostrarMensagem("Nenhum item selecionado para exclusão");
      return;
    }

    try {
      setLoading(true);

      // 1. Deletar todos os itens do ItemsFichaTecnica (endpoint principal)
      const itemsResponse = await fetch(`${_url}/items-ficha-tecnica/remover-multiplos`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem("usuarioToken")}`
        },
        body: JSON.stringify(selectedItems)
      });

      // Verifica o resultado do endpoint principal
      if (!itemsResponse.ok) {
        let errorText = 'Falha ao deletar itens da ficha técnica';
        try {
          const txt = await itemsResponse.text();
          if (txt) errorText = txt;
        } catch (e) {
          // ignore
        }
        throw new Error(errorText);
      }

      // 2. Deletar itens DXF em paralelo (opcional, não bloqueia o sucesso)
      const dxfPromises = selectedItems.map(id => 
        fetch(`${_url}/api/dxf/deletar/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem("usuarioToken")}`
          }
        }).catch(err => {
          // Log mas não falha o processo principal
          console.warn(`Falha ao deletar DXF ${id}:`, err);
          return null;
        })
      );

      // Aguarda DXF deletions sem bloquear o fluxo
      await Promise.allSettled(dxfPromises);

      // Sucesso: mostrar mensagem e recarregar
      mostrarMensagem(`${selectedItems.length} item(s) excluído(s) com sucesso`);
      setSelectedItems([]);
      
      // Recarregar a página para garantir que os dados estejam atualizados
      await recarregarItemsFicha();

    } catch (error) {
      // Exibe mensagem detalhada quando o backend retornou texto explicativo
      console.error('Erro ao excluir itens:', error);
      const msg = error && error.message ? error.message : 'Erro ao excluir itens';
      mostrarMensagem(msg);
    } finally {
      setLoading(false);
    }
  };
  const limparFicha = () => {
    setObjItemsFicha(itemsFichaTecnica);
    setUltimoEncaixeCalculado(null);
    setBtnItemsFicha(true);
  };

  const handleVerPdf = (pdfId) => {
    if (!pdfId) {
      mostrarMensagem("Este item não possui um PDF associado.");
      return;
    }
    // A URL deve corresponder ao seu endpoint de download no backend
    const pdfUrl = `${_url}/api/dxf/download/${pdfId}`;
    window.open(pdfUrl, '_blank');
  };

  const selecionarItemsFicha = (itemId, idProdutoParam, idMateriaPrimaParam) => {
    // Sempre buscar pelo id do item (não usar índice)
    const foundItem = ItemsFichaTecnicas.find(item => String(item.id) === String(itemId));
    if (!foundItem) {
      console.warn('Item não encontrado para seleção:', itemId);
      mostrarMensagem('Item não encontrado');
      return;
    }

    // Consolidar campos, garantindo que o id esteja presente
    const resolvedIdProduto = idProdutoParam ?? foundItem?.idProduto ?? foundItem?.produto?.idProduto ?? idProduto;
    const resolvedIdMateria = idMateriaPrimaParam ?? foundItem?.idMateriaPrima ?? foundItem?.materiaPrima?.id ?? 0;

    setObjItemsFicha(prev => ({
      ...prev,
      ...foundItem,
      id: foundItem.id,
      idProduto: resolvedIdProduto,
      idMateriaPrima: resolvedIdMateria,
    }));

    setBtnItemsFicha(false);
    setOpenModal(true);
  };

  //corregar o produto e as materia primas na botao de (Cadastra items na ficha tencica)
  useEffect(() => {
    if (idFichaTecnica && idProduto) {
      carregarProduto();
      carregarMateriaPrimas();
      carregarDadosProduto();
      recarregarItemsFicha();
    }
  }, [idFichaTecnica, idProduto, recarregarItemsFicha, carregarMateriaPrimas, carregarProduto, carregarDadosProduto]);

  // Debug: log route params and key state to confirm we're on the expected page
  useEffect(() => {
    try {
      console.debug('[DEBUG] ItemsFichaTecnica - route params', { idFichaTecnica, idProduto, pathname: window.location.pathname });
    } catch (e) {
      console.debug('[DEBUG] ItemsFichaTecnica - route params (no window)', { idFichaTecnica, idProduto });
    }
  }, [idFichaTecnica, idProduto]);

  useEffect(() => {
    console.debug('[DEBUG] ItemsFichaTecnica - produtoInfo updated:', produtoInfo);
  }, [produtoInfo]);

  useEffect(() => {
    console.debug('[DEBUG] ItemsFichaTecnica - variacoes updated:', variacoes);
  }, [variacoes]);

  // carregar variações do produto (filhos) quando produtoInfo for carregado
  // NOTE: If the current produtoInfo is a child (has parentProductId) we fetch the parent and the parent's
  // variations so the select list always contains the parent + siblings. This avoids a race where
  // the raw fetch of child-variations would overwrite an injected parent.
  useEffect(() => {
    if (!produtoInfo || !produtoInfo.idProduto) return;

    const carregar = async () => {
      try {
        const headers = { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` };

        let candidateParentId = produtoInfo.parentProductId || produtoInfo.parentId || produtoInfo.parent_product_id || null;

        // If produtoInfo is a child and we know its parent, fetch parent + parent's variations
        if (candidateParentId && String(candidateParentId) !== String(produtoInfo.idProduto)) {
          const [parentResp, varsResp] = await Promise.all([
            fetch(`${_url}/produto/${candidateParentId}`, { headers }),
            fetch(`${_url}/produto/${candidateParentId}/variacoes`, { headers })
          ]);

          const parentRaw = parentResp.ok ? await parentResp.json() : null;
          const varsRaw = varsResp.ok ? await varsResp.json() : [];
          const normalizedVars = normalizeVariacoes(varsRaw || []);
          const normalizedParent = parentRaw ? normalizeVariacoes([parentRaw])[0] : null;

          if (normalizedParent) {
            // ensure parent at top and avoid duplicates
            const filtered = normalizedVars.filter(v => String(v.idProduto) !== String(normalizedParent.idProduto));
            setVariacoes([normalizedParent, ...filtered]);
            rememberParentFromNormalized([normalizedParent, ...filtered]);
          } else {
            setVariacoes(normalizedVars);
            rememberParentFromNormalized(normalizedVars);
          }

        } else {
          // produtoInfo might be the parent or we don't have parent id on produtoInfo
          // Fetch variations for the current produtoInfo.idProduto and then try to derive parent from them
          const resp = await fetch(`${_url}/produto/${produtoInfo.idProduto}/variacoes`, { headers });
          const list = resp.ok ? await resp.json() : [];
          const normalized = normalizeVariacoes(list || []);

          // Try to derive parent id from variations' raw data if produtoInfo lacks it
          if (!candidateParentId) {
            const derived = normalized.find(v => v && v._raw && (v._raw.parentProductId || v._raw.parentId || v._raw.parent_product_id || v._raw.parent));
            if (derived) {
              candidateParentId = derived._raw.parentProductId || derived._raw.parentId || derived._raw.parent_product_id || derived._raw.parent || null;
            }
          }

          // If we derived a parent, and it's different, fetch the parent and place it on top
          if (candidateParentId && String(candidateParentId) !== String(produtoInfo.idProduto)) {
            try {
              const parentResp = await fetch(`${_url}/produto/${candidateParentId}`, { headers });
              const parentRaw = parentResp.ok ? await parentResp.json() : null;
              const normalizedParent = parentRaw ? normalizeVariacoes([parentRaw])[0] : null;
              if (normalizedParent) {
                const filtered = normalized.filter(v => String(v.idProduto) !== String(normalizedParent.idProduto));
                setVariacoes([normalizedParent, ...filtered]);
                rememberParentFromNormalized([normalizedParent, ...filtered]);
              } else {
                setVariacoes(normalized);
                rememberParentFromNormalized(normalized);
              }
            } catch (e) {
              console.warn('Erro ao buscar parent derivado:', e);
              setVariacoes(normalized);
              rememberParentFromNormalized(normalized);
            }
          } else {
            // No parent derivable — ensure product itself is first option
            const selfEntry = {
              idProduto: produtoInfo.idProduto,
              nomeModelo: produtoInfo.nomeModelo || produtoInfo.nome || '',
              cor: produtoInfo.cor || produtoInfo.colorVariation || produtoInfo.nomeCor || '',
              referencia: produtoInfo.referencia || '',
              marca: produtoInfo.marca || '',
              image: produtoInfo.image || null,
              fichaId: produtoInfo.fichaId || (produtoInfo.fichaIds && produtoInfo.fichaIds[0]) || null,
              _raw: produtoInfo
            };
            const alreadyHasSelf = normalized.some(v => String(v.idProduto) === String(selfEntry.idProduto));
            if (!alreadyHasSelf) {
              setVariacoes([selfEntry, ...normalized]);
              rememberParentFromNormalized([selfEntry, ...normalized]);
            } else {
              setVariacoes(normalized);
              rememberParentFromNormalized(normalized);
            }
          }
        }
      } catch (err) {
        console.warn('Erro ao carregar variações para produto:', err);
        setVariacoes([]);
      }
    };

    carregar();
  }, [produtoInfo, _url]);

  // helpers para fetch consistente
  const fetchProdutoById = async (pid) => {
    try {
      const resp = await fetch(`${_url}/produto/${pid}`, { headers: { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
      if (!resp.ok) return null;
      return await resp.json();
    } catch (e) {
      return null;
    }
  };

  

  const fetchItemsByProductId = async (fid, pid) => {
    try {
      const resp = await fetch(`${_url}/items-ficha-tecnica/${fid}/${pid}`, { headers: { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
      if (!resp.ok) return null;
      return await resp.json();
    } catch (e) {
      return null;
    }
  };

  // normalize variations helper to keep UI consistent
  const normalizeVariacoes = (list) => {
    if (!Array.isArray(list)) return [];
    return list.map(v => ({
      idProduto: v.idProduto || v.id || v.productId || null,
      nomeModelo: v.nomeModelo || v.nome || v.modelName || '',
      // prefer 'cor' (backend stores variation color in 'cor')
      cor: v.cor || v.colorVariation || v.nomeCor || '',
      // parent/pilot color if provided by backend
      corPiloto: v.corPiloto || v.parentColor || null,
      referencia: v.referencia || v.reference || v.ref || '',
      marca: v.marca || v.brand || '',
      image: v.image || v.imagem || v.imagemBase64 || null,
      _raw: v,
      fichaId: (v.fichaIds && v.fichaIds.length) ? v.fichaIds[0] : (v.fichaId || null)
    }));
  };

  // Try to detect a parent object inside a normalized variations list and remember it
  const rememberParentFromNormalized = (normalizedList) => {
    if (!Array.isArray(normalizedList) || normalizedList.length === 0) return null;
    // Heuristic: parent is likely the entry without a corPiloto/parentColor or the one that looks like the model root
    const candidate = normalizedList.find(v => !v.corPiloto && !v._raw?.parentProductId && !v._raw?.parentId && !v._raw?.parent_product_id && !v._raw?.parent);
    if (candidate) {
      setLastKnownParent(candidate);
      return candidate;
    }
    return null;
  };

  // remover variação de cor (chama endpoint DELETE /produto/{idProduto}/variacao)
  const handleRemoverVariacao = async () => {
    if (!produtoInfo || !produtoInfo.idProduto) {
      mostrarMensagem('Produto não carregado');
      return;
    }
    // proteger contra remoção do produto pai
    if (!produtoInfo.parentProductId) {
      mostrarMensagem('Este produto não é uma variação e não pode ser removido por aqui.');
      return;
    }

    setModalConfirm({
      open: true,
      title: 'Remover Variação',
      message: 'Confirma remoção desta variação? Esta ação irá apagar a variação (e imagens) permanentemente.',
      type: 'warning',
      confirmText: 'Sim, Remover',
      cancelText: 'Cancelar',
      onConfirm: async () => {
        setModalConfirm(prev => ({ ...prev, open: false }));
        try {
          setLoading(true);
          const resp = await fetch(`${_url}/produto/${produtoInfo.idProduto}/variacao`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` }
          });
          if (!resp.ok) {
            const txt = await resp.text();
            mostrarMensagem(txt || `Falha ao remover variação (${resp.status})`);
            return;
          }

          mostrarMensagem('Variação removida com sucesso');

          // navegar para o produto pai (se conhecido)
          const parentId = produtoInfo.parentProductId || produtoInfo.parentId || null;
          if (parentId) {
            // tentar obter ficha do pai
            const fichas = await fetchFichaByProduto(parentId);
            const fichaToUse = (Array.isArray(fichas) && fichas.length) ? fichas[0] : idFichaTecnica;
            // recarregar variações do pai e navegar para a página do pai
            try {
              const varsResp = await fetch(`${_url}/produto/${parentId}/variacoes`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
              if (varsResp.ok) {
                const vars = await varsResp.json();
                setVariacoes(normalizeVariacoes(vars));
              } else {
                setVariacoes([]);
              }
            } catch (e) {
              setVariacoes([]);
            }

            navigate(`/itemsDaFichaTecnica/ItemsFichaTecnica/${fichaToUse}/${parentId}`);
          } else {
            navigate('/itemsDaFichaTecnica');
          }
        } catch (err) {
          mostrarMensagem('Erro ao remover variação: ' + err.message);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // Helper para resolver gradeNumeracao do item (aceita string JSON ou objeto)
  const getGradeNumeracao = (item) => {
    if (!item) return {};
    if (item.gradeNumeracao && typeof item.gradeNumeracao === 'object') return item.gradeNumeracao;
    if (item.grade_numeracao_json) {
      try {
        return typeof item.grade_numeracao_json === 'string' ? JSON.parse(item.grade_numeracao_json) : item.grade_numeracao_json;
      } catch (e) {
        console.warn('Falha ao parsear grade_numeracao_json', e);
        return {};
      }
    }
    if (item.gradeNumeracaoJson) {
      try {
        return typeof item.gradeNumeracaoJson === 'string' ? JSON.parse(item.gradeNumeracaoJson) : item.gradeNumeracaoJson;
      } catch (e) {
        return {};
      }
    }
    return item.grade || {};
  };


  return (
    <div>
      {loadingPython && (
        <Box sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255,255,255,0.6)',
          zIndex: 2000
        }}>
          <LoadingSpinner message="Carregando DXF..." />
        </Box>
      )}

      <Button variant="contained" onClick={voltarParaProduto} startIcon={<ArrowBackIcon />}>
        Voltar
      </Button>

      {/* Adicione esta seção para exibir as informações do produto */}
      {produtoInfo ? (
        <Box className="ift-product-header" sx={{  // Troquei Paper por Box para remover os estilos padrão do Paper
          display: 'flex',
          alignItems: 'center',
        }}>
          {/* Container da Imagem */}
          <Box className="ift-product-image" sx={{
            width: '160px',
            height: '160px',
            marginRight: '25px',
            borderRadius: '4px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            position: 'relative'
          }}>
            {produtoInfo.image ? (
              <img
                src={produtoInfo.image.startsWith('http') ?
                  produtoInfo.image :
                  `data:image/jpeg;base64,${produtoInfo.image}`}
                alt={produtoInfo.nomeModelo || 'Produto sem nome'}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  document.getElementById('fallback-image').style.display = 'flex';
                }}
              />
            ) : null}

            {/* Fallback para quando a imagem não carrega ou não existe */}
            <Box id="fallback-image" sx={{
              display: produtoInfo.image ? 'none' : 'flex',
              position: 'absolute',
              width: '100%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#757575',
              fontSize: '0.75rem'
            }}>
              {produtoInfo.image ? 'Erro ao carregar imagem' : 'Sem imagem'}
            </Box>
          </Box>

          {/* Dados do produto */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" className="ift-product-title" sx={{
              marginBottom: '8px',
              fontWeight: 'bold',
              color: 'primary.main'
            }}>
              {produtoInfo.nomeModelo || 'Produto sem nome'}
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={2} sm={2}>
                <Typography variant="body2">
                  <Box component="span" sx={{ fontWeight: 'bold' }}>Cor:</Box> {produtoInfo.cor || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2}>
                <Typography variant="body2">
                  <Box component="span" sx={{ fontWeight: 'bold' }}>Marca:</Box> {produtoInfo.marca || 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2}>
                <Typography variant="body2">
                  <Box component="span" sx={{ fontWeight: 'bold' }}>Referência:</Box> {produtoInfo.referencia || 'N/A'}
                </Typography>
              </Grid>
            </Grid>
            {/* Select de variações de cor (filhos) */}
            <Box sx={{ mt: 2 }}>
              {produtoInfo && (
                <select value={String(idProduto)} onChange={async (e) => {
                  const newId = e.target.value;
                  // find the variation object (or fallback to produtoInfo)
                  const chosen = variacoes.find(v => String(v.idProduto) === String(newId)) || { idProduto: newId, fichaId: null, nomeModelo: produtoInfo.nomeModelo, cor: produtoInfo.cor || produtoInfo.colorVariation || '', referencia: produtoInfo.referencia, marca: produtoInfo.marca, image: produtoInfo.image };

                  // If the chosen option is a placeholder for the parent, resolve the parent's ficha and product first
                  let fichaToUse = chosen.fichaId || idFichaTecnica;
                  if (chosen && chosen._placeholder) {
                    try {
                      // try to resolve the correct ficha for the parent
                      const fichasDoPai = await fetchFichaByProduto(newId);
                      if (Array.isArray(fichasDoPai) && fichasDoPai.length) fichaToUse = fichasDoPai[0];
                      // fetch actual parent product so UI updates immediately
                      const parentProd = await fetchProdutoById(newId);
                      if (parentProd) setProdutoInfo(parentProd);
                    } catch (err) {
                      console.warn('Falha ao resolver parent placeholder:', err);
                    }
                  }

                  // navegar para rota com ficha correta
                  navigate(`/itemsDaFichaTecnica/ItemsFichaTecnica/${fichaToUse}/${newId}`);
                  // em seguida busca produto e items de forma consistente usando fichaToUse
                  try {
                    const [prod, items] = await Promise.all([fetchProdutoById(newId), fetchItemsByProductId(fichaToUse, newId)]);
                    if (prod) setProdutoInfo(prod);
                    if (items) {
                      setItensFichaTecnicas(items.itemsFichaTecnicas || []);
                      setItemsFichaTecnicaFiltra(items.itemsFichaTecnicas || []);
                      setCustoTotal(items.custoTotal || []);
                    } else {
                      setItensFichaTecnicas([]);
                      setItemsFichaTecnicaFiltra([]);
                      setCustoTotal([]);
                    }
                  } catch (err) {
                    console.error('Erro ao trocar variação:', err);
                    mostrarMensagem('Falha ao carregar variação selecionada');
                  }
                }}>
                  {(() => {
                    const list = Array.isArray(variacoes) ? [...variacoes] : [];
                    // diagnostic logs to debug missing parent option
                    console.log('[DEBUG] ItemsFichaTecnica - produtoInfo for select:', produtoInfo);
                    console.log('[DEBUG] ItemsFichaTecnica - variacoes state before build:', variacoes);
                    // determine parent id: prefer explicit parent on produtoInfo, else try to derive from variacoes raw data
                    let derivedParentId = produtoInfo?.parentProductId || produtoInfo?.parentId || produtoInfo?.parent_product_id || null;
                    if (!derivedParentId) {
                      const found = variacoes.find(v => v && v._raw && (v._raw.parentProductId || v._raw.parentId || v._raw.parent_product_id || v._raw.parent));
                      if (found) derivedParentId = found._raw.parentProductId || found._raw.parentId || found._raw.parent_product_id || found._raw.parent || null;
                    }

                    const isChild = Boolean(derivedParentId && String(derivedParentId) !== String(produtoInfo?.idProduto));
                    const hasParent = derivedParentId ? list.some(v => String(v.idProduto) === String(derivedParentId)) : false;
                    console.log('[DEBUG] ItemsFichaTecnica - derivedParentId:', derivedParentId, 'isChild:', isChild, 'hasParent:', hasParent);

                    // If the parent is not present yet:
                    // - If produtoInfo appears to be the parent (not a child), it's safe to add produtoInfo itself
                    // - If produtoInfo is a child, don't fabricate parent details from the child's fields.
                    //   Instead add a lightweight placeholder option so the user can navigate back to the parent immediately.
                    if (derivedParentId && !hasParent) {
                      if (!isChild) {
                        const parentObj = { idProduto: derivedParentId, nomeModelo: produtoInfo?.nomeModelo || '', cor: produtoInfo?.cor || produtoInfo?.colorVariation || '', referencia: produtoInfo?.referencia || '', marca: produtoInfo?.marca || '', image: produtoInfo?.image || null, fichaId: null };
                        console.log('[DEBUG] ItemsFichaTecnica - unshifting produtoInfo as parent into list:', parentObj);
                        list.unshift(parentObj);
                        // remember parent
                        setLastKnownParent(parentObj);
                      } else {
                        // lightweight placeholder; real parent details will be injected by the effect that fetches the parent
                        const placeholder = { idProduto: derivedParentId, nomeModelo: 'Pai (carregando...)', cor: '', referencia: '', marca: '', image: null, fichaId: null, _placeholder: true };
                        console.log('[DEBUG] ItemsFichaTecnica - inserting parent placeholder into list:', placeholder);
                        // ensure placeholder goes to the top but avoid duplicate placeholders
                        if (!list.some(v => v && v._placeholder && String(v.idProduto) === String(derivedParentId))) {
                          list.unshift(placeholder);
                        }
                        // keep lastKnownParent if we had it before
                        if (!lastKnownParent) setLastKnownParent(placeholder);
                      }
                    } else if (!derivedParentId && lastKnownParent) {
                      // fallback: if we have a remembered parent from initial load, ensure it's present
                      if (!list.some(v => String(v.idProduto) === String(lastKnownParent.idProduto))) {
                        console.log('[DEBUG] ItemsFichaTecnica - reinserting lastKnownParent into list as fallback:', lastKnownParent);
                        list.unshift(lastKnownParent);
                      }
                    }
                    console.log('[DEBUG] ItemsFichaTecnica - final list for select:', list);
                    return list.map(v => (
                      <option key={(v && v.idProduto) || Math.random()} value={String(v.idProduto)}>{v && v._placeholder ? `Pai - Voltar para cor do pai (ID ${v.idProduto})` : ((v && v.cor && String(v.cor).trim()) ? v.cor : `Pai - ${v && v.nomeModelo ? v.nomeModelo : ''}`)}</option>
                    ));
                  })()}
                </select>
              )}
                {/* Botão para abrir modal de criar variação */}
                <Button sx={{ ml: 2 }} variant="outlined" onClick={() => setOpenVariacaoModal(true)}>Criar variação</Button>
                <Button sx={{ ml: 2 }} variant="outlined" onClick={() => {
                  // open edit modal prefilled with parent product data
                  if (!produtoInfo) { mostrarMensagem('Produto não carregado'); return; }
                  setEditarNomeModelo(produtoInfo.nomeModelo || '');
                  setEditarCor(produtoInfo.colorVariation || produtoInfo.cor || '');
                  setEditarMarca(produtoInfo.marca || '');
                  setEditarReferencia(produtoInfo.referencia || '');
                  setEditarImageFile(null);
                  setEditarPreview(produtoInfo.image && produtoInfo.image.startsWith('http') ? produtoInfo.image : (produtoInfo.image ? `data:image/jpeg;base64,${produtoInfo.image}` : null));
                  setOpenEditarVariacaoModal(true);
                }}>Editar variação</Button>
                <Button sx={{ ml: 2 }} variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={async () => {
                  // call remover variação handler
                  if (!produtoInfo) { mostrarMensagem('Produto não carregado'); return; }
                  await handleRemoverVariacao();
                }}>Remover variação</Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box sx={{
          padding: '20px',
          backgroundColor: '#fff8e1',
          borderRadius: '8px',
          textAlign: 'center',
          margin: '20px 0'
        }}>
          <CircularProgress size={24} sx={{ marginRight: '10px' }} />
          <Typography variant="body2">Carregando informações do produto...</Typography>
        </Box>
      )}

        {/* Modal para editar variação (nome modelo, cor, marca, referencia, imagem) */}
        <Modal open={openEditarVariacaoModal} onClose={() => setOpenEditarVariacaoModal(false)}>
          <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 520, p: 4 }}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6">Editar variação</Typography>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <input placeholder="Nome do modelo" value={editarNomeModelo} onChange={(e) => setEditarNomeModelo(e.target.value)} />
                <input placeholder="Cor" value={editarCor} onChange={(e) => setEditarCor(e.target.value)} />
                <input placeholder="Marca" value={editarMarca} onChange={(e) => setEditarMarca(e.target.value)} />
                <input placeholder="Referência" value={editarReferencia} onChange={(e) => setEditarReferencia(e.target.value)} />
                <input type="file" accept="image/*" onChange={(e) => {
                  const file = e.target.files && e.target.files[0];
                  if (!file) { setEditarImageFile(null); setEditarPreview(null); return; }
                  if (file.size > MAX_IMAGE_SIZE) { mostrarMensagem('Arquivo muito grande. Máx 5MB'); setEditarImageFile(null); setEditarPreview(null); return; }
                  setEditarImageFile(file);
                  try { const url = URL.createObjectURL(file); setEditarPreview(url); } catch (err) { setEditarPreview(null); }
                }} />
                {editarPreview && (
                  <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                    <img src={editarPreview} alt="preview" style={{ maxWidth: 160, maxHeight: 120, objectFit: 'contain', borderRadius: 4 }} />
                  </Box>
                )}
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                  <Button variant="text" onClick={() => { if (editarPreview && editarImageFile) { try { URL.revokeObjectURL(editarPreview); } catch(e){} } setOpenEditarVariacaoModal(false); }}>Cancelar</Button>
                  <Button
                    variant="contained"
                    disabled={editingVariacao}
                    onClick={async () => {
                      if (!produtoInfo || !produtoInfo.idProduto) { mostrarMensagem('Produto não carregado'); return; }
                      setEditingVariacao(true);
                      try {
                        const idEmpresa = produtoInfo?.idEmpresa?.id ?? produtoInfo?.idEmpresa ?? null;
                        const dto = {
                          nomeModelo: editarNomeModelo,
                          cor: editarCor,
                          marca: editarMarca,
                          referencia: editarReferencia,
                          idEmpresa: idEmpresa
                        };
                        const form = new FormData();
                        const blob = new Blob([JSON.stringify(dto)], { type: 'application/json' });
                        form.append('produto', blob);
                        if (editarImageFile) form.append('imageFile', editarImageFile);

                        const resp = await fetch(`${_url}/produto/${produtoInfo.idProduto}/variacao`, {
                          method: 'PUT',
                          body: form,
                          headers: { 'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}` }
                        });

                        if (!resp.ok) {
                          const txt = await resp.text();
                          try { const parsed = JSON.parse(txt); throw new Error(parsed.message || parsed.error || JSON.stringify(parsed)); } catch (pe) { throw new Error(txt || 'Falha ao atualizar variação'); }
                        }

                        const updated = await resp.json();

                        // atualizar produtoInfo com a resposta atualizada
                        const prod = await fetchProdutoById(updated.idProduto || produtoInfo.idProduto);
                        if (prod) setProdutoInfo(prod);

                        // determinar parentId: se updated for uma variação (tem parentProductId) usar ele,
                        // caso contrário usar o próprio id (produto pai)
                        const parentId = (updated.parentProductId && Number(updated.parentProductId)) || (updated.idProduto && Number(updated.idProduto)) || (produtoInfo && produtoInfo.parentProductId) || (produtoInfo && produtoInfo.idProduto);

                        // buscar variações do parent correto
                        try {
                          const varsResp = await fetch(`${_url}/produto/${parentId}/variacoes`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
                            if (varsResp.ok) {
                              const vars = await varsResp.json();
                              setVariacoes(normalizeVariacoes(vars));
                            } else {
                              setVariacoes([]);
                            }
                        } catch (e) {
                          console.error('Erro ao recarregar variações:', e);
                          setVariacoes([]);
                        }

                        // cleanup preview URL
                        if (editarPreview && editarImageFile) { try { URL.revokeObjectURL(editarPreview); } catch(e){} }
                        setEditarImageFile(null);
                        setEditarPreview(null);
                        setOpenEditarVariacaoModal(false);
                        mostrarMensagem('Variação atualizada com sucesso');
                      } catch (err) {
                        console.error('Erro atualizar variação:', err);
                        mostrarMensagem(err.message || 'Erro ao atualizar variação');
                      } finally {
                        setEditingVariacao(false);
                      }
                    }}
                  >
                    {editingVariacao ? 'Salvando...' : 'Salvar'}
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Box>
        </Modal>

      {/* Modal para criar variação de cor */}
      <Modal open={openVariacaoModal} onClose={() => setOpenVariacaoModal(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 520, p: 4 }}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6">Criar variação de cor</Typography>
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <input placeholder="Nome da cor" value={novaCorNome} onChange={(e) => setNovaCorNome(e.target.value)} />
              <input type="file" accept="image/*" onChange={(e) => {
                const file = e.target.files && e.target.files[0];
                if (!file) {
                  setNovaCorImage(null);
                  setNovaCorPreview(null);
                  setImageTooLarge(false);
                  return;
                }
                if (file.size > MAX_IMAGE_SIZE) {
                  setNovaCorImage(null);
                  setNovaCorPreview(null);
                  setImageTooLarge(true);
                  mostrarMensagem('Arquivo muito grande. Máx 5MB');
                  return;
                }
                setImageTooLarge(false);
                setNovaCorImage(file);
                try {
                  const url = URL.createObjectURL(file);
                  setNovaCorPreview(url);
                } catch (err) {
                  setNovaCorPreview(null);
                }
              }} />
              {novaCorPreview && (
                <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                  <img src={novaCorPreview} alt="preview" style={{ maxWidth: 160, maxHeight: 120, objectFit: 'contain', borderRadius: 4 }} />
                </Box>
              )}
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                <Button variant="text" onClick={() => setOpenVariacaoModal(false)}>Cancelar</Button>
                <Button
                  variant="contained"
                  disabled={creatingVariacao || !novaCorNome || imageTooLarge}
                  onClick={async () => {
                    // enviar multipart para backend e navegar para variação criada
                    if (!novaCorNome) { mostrarMensagem('Informe o nome da cor'); return; }
                    if (imageTooLarge) { mostrarMensagem('Arquivo muito grande. Máx 5MB'); return; }
                    setCreatingVariacao(true);
                    try {
                      const formData = new FormData();
                      formData.append('cor', novaCorNome);
                      // send nomeModelo and referencia (use parent product values)
                      formData.append('nomeModelo', produtoInfo?.nomeModelo || '');
                      formData.append('referencia', produtoInfo?.referencia || '');
                      if (novaCorImage) formData.append('imageFile', novaCorImage);

                      const resp = await fetch(`${_url}/produto/${produtoInfo.idProduto}/copiar-com-cor`, {
                        method: 'POST',
                        body: formData,
                        headers: {
                          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
                        }
                      });

                      if (!resp.ok) {
                        // tenta extrair JSON.message ou texto cru para mensagem detalhada
                        const txt = await resp.text();
                        try {
                          const parsed = JSON.parse(txt);
                          const msg = parsed.message || parsed.error || JSON.stringify(parsed);
                          throw new Error(msg);
                        } catch (parseErr) {
                          throw new Error(txt || 'Falha ao criar variação');
                        }
                      }

                      const created = await resp.json();
                      // show backend warning if present (e.g., when creating from a variation)
                      if (created && created.warningMessage) {
                        mostrarMensagem(created.warningMessage);
                      }
                      // created expected: { produto: {...}, fichaIds: [...] }
                      const newProd = created.produto || created;
                      let fichaIds = created.fichaIds || [];
                      // fallback: if backend didn't return fichaIds, ask ficha-tecnica endpoint
                      if ((!fichaIds || fichaIds.length === 0) && newProd && (newProd.idProduto || newProd.id)) {
                        const fetched = await fetchFichaByProduto(newProd.idProduto || newProd.id);
                        if (Array.isArray(fetched) && fetched.length) fichaIds = fetched;
                      }
                      const fichaId = fichaIds.length ? fichaIds[0] : null;
                      // atualizar lista de variações usando parentId endpoint quando possível
                      try {
                        const parentId = produtoInfo.parentProductId || produtoInfo.idProduto || (newProd.parentProductId || newProd.idProduto);
                        const varsResp = await fetch(`${_url}/produto/${parentId}/variacoes`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
                        const varsJson = varsResp.ok ? await varsResp.json() : [];
                        setVariacoes(normalizeVariacoes(varsJson));
                      } catch (e) {
                        // fallback to raw list
                        const newVariacoes = await fetch(`${_url}/produto/${produtoInfo.idProduto}/variacoes`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } }).then(r => r.json());
                        setVariacoes(normalizeVariacoes(newVariacoes));
                      }
                      // limpar preview e inputs
                      if (novaCorPreview) { try { URL.revokeObjectURL(novaCorPreview); } catch(e){} }
                      setNovaCorPreview(null);
                      setNovaCorImage(null);
                      setNovaCorNome('');
                      // revoke preview URL and close modal
                      if (novaCorPreview) { try { URL.revokeObjectURL(novaCorPreview); } catch(e){} }
                      setOpenVariacaoModal(false);
                      mostrarMensagem('Variação criada com sucesso');
                      // navegar para a nova variação usando fichaId quando disponível
                      if (fichaId) {
                        navigate(`/itemsDaFichaTecnica/ItemsFichaTecnica/${fichaId}/${newProd.idProduto || newProd.id}`);
                      } else {
                        // fallback para manter compatibilidade
                        navigate(`/itemsDaFichaTecnica/ItemsFichaTecnica/${idFichaTecnica}/${newProd.idProduto || newProd.id}`);
                      }
                    } catch (e) {
                      console.error('Erro criar variação:', e);
                      mostrarMensagem(e.message || 'Erro ao criar variação');
                    } finally {
                      setCreatingVariacao(false);
                    }
                  }}
                >
                  {creatingVariacao ? 'Criando...' : 'Criar'}
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Modal>

      

      <Modal open={openModal} onClose={handleCloseModal} disableEnforceFocus disableAutoFocus>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          p: 10,
        }}>
          <Paper style={{
            color: 'white',
            textAlign: 'center',
            fontSize: '16px',
          }}>
            <ItemsFichaTecnicaFormulario
              botao={bntItemsFicha}
              eventoTeclado={aoDigitar}
              cadastrarItemsFichaTecnica={handleCadastrar}
              objItemsFicha={objItemsFicha}
              produtos={produtos}
              materiaPrimas={materiaPrimas}
              recarregarItensFicha={recarregarItemsFicha}
              alterarItemsFicha={alterarItemsFicha}
              remover={remover}
              filtrarComponentes={filtrarComponentes}
              onEncaixeManual={(numero, componente) => {
                setNumeroParaEncaixeManual(numero);
                setComponenteParaEncaixeManual(componente || null);
                setShowEncaixeManual(true);
              }}
            />
            <Button onClick={handleOpenEncaixeManual} variant="outlined" sx={{ marginTop: '10px', marginRight: '10px' }}>
              Encaixe Manual
            </Button>
            <Button onClick={handleCloseModal} variant="contained" sx={{ marginTop: '10px' }}>Fechar</Button>
          </Paper>
        </Box>
      </Modal>

      {showEncaixeManual && (
        <EncaixeManualDXF
          dxfId={objItemsFicha.dxfFileId || objItemsFicha.id}
          pecasDoDXF={pecasDoDXF}
          pecaSelecionadaIndex={pecaSelecionadaIndex}
          onPecaSelect={setPecaSelecionadaIndex}
          preloadedDXFFile={dxfMultiPecasFile}
          numeroGrade={numeroParaEncaixeManual}
          componente={componenteParaEncaixeManual}
          onClose={handleCloseEncaixeManual}
          onConsumoCalculado={(valor) => {
            console.log('[DEBUG] onConsumoCalculado invoked:', { valor, openGradeModal, numeroParaEncaixeManual, componenteParaEncaixeManual });
            if (valor && typeof valor === 'object') {
              setUltimoEncaixeCalculado(valor);
            }
            // Prefer the numero/componente returned from EncaixeManualDXF (resultWithContext)
            const targetNumero = (valor && (valor.numeroGrade || valor.numero_grade)) || numeroParaEncaixeManual;

            // Extract a numeric/string consumo value if present. Avoid storing the whole result object.
            let consumoValor = null;
            if (valor && typeof valor === 'object') {
              consumoValor = (valor.consumo_min_rotated_rect ?? valor.consumo ?? null);
            } else if (valor !== undefined && valor !== null) {
              consumoValor = valor;
            }

            if (consumoValor === null || consumoValor === undefined || (typeof consumoValor === 'object')) {
              console.warn('[WARN] onConsumoCalculado: backend não retornou consumo numérico. Evitando sobrescrever grade com objeto.', { valor });
              mostrarMensagem('Cálculo concluído, mas resposta não contém valor de consumo');
            } else {
              if (openGradeModal) {
                if (targetNumero) {
                  setGradeNumeracao((prev) => ({ ...prev, [targetNumero]: consumoValor }));
                  mostrarMensagem(`Consumo calculado para número ${targetNumero}: ${consumoValor}`);
                }
              } else if (targetNumero) {
                setObjItemsFicha((prev) => ({
                  ...prev,
                  gradeNumeracao: {
                    ...(prev.gradeNumeracao || {}),
                    [targetNumero]: consumoValor
                  }
                }));
                mostrarMensagem(`Consumo calculado para número ${targetNumero}: ${consumoValor}`);
              } else {
                setObjItemsFicha((prev) => ({ ...prev, consumo: consumoValor }));
                mostrarMensagem(`Consumo calculado: ${consumoValor}`);
              }
            }

            setShowEncaixeManual(false);
            setNumeroParaEncaixeManual(null);
            setComponenteParaEncaixeManual(null);
          }}
          // Estados para campos manuais do modal de grade
          quantidadePares={openGradeModal ? quantidadeParesGrade : undefined}
          setQuantidadePares={openGradeModal ? setQuantidadeParesGrade : undefined}
          quantidadePeca={openGradeModal ? quantidadePecaGrade : undefined}
          setQuantidadePeca={openGradeModal ? setQuantidadePecaGrade : undefined}
          espacamento={openGradeModal ? espacamentoGrade : undefined}
          setEspacamento={openGradeModal ? setEspacamentoGrade : undefined}
          percentualPerda={openGradeModal ? percentualPerdaGrade : undefined}
          setPercentualPerda={openGradeModal ? setPercentualPerdaGrade : undefined}
        />
      )}

      {/* Filtro por componentes / Toolbar */}
      <div className="ift-toolbar" style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "10px 0", gap: "10px" }}>
        <Select
          value={options.find(option => option.value === componentes)}
          onChange={handleSelectChange}
          options={options}
          isClearable={true}
          isSearchable={true}
          placeholder="Consultar Componentes"
          className="w-auto fixed-select"
        />
        {/* Botão de Buscar */}
        <button className="btn btn-primary" onClick={handleBuscar}>
          Buscar
        </button>
        {/* Consultar Grade moved into the Cadastrar Grade modal (GradeFormulario) */}
        <PermissionGate permissions={["fichaTecnicaItensCadastrar"]}>
          <Button variant="contained" onClick={handleOpenModal}>
            Cadastrar Item
          </Button>
          <Button variant="outlined" sx={{ ml: 2 }} onClick={() => setOpenGradeModal(true)}>
            Cadastrar Grade
          </Button>
        </PermissionGate>
        
        {/* Botão para carregar DXF com múltiplas peças */}
        <PermissionGate permissions={["fichaTecnicaItensCadastrar"]}>
          <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '10px', gap: '8px' }}>
            <input 
              type="file" 
              accept=".dxf" 
              onChange={(e) => setDxfMultiPecasFile(e.target.files[0])}
              style={{ fontSize: '14px' }}
            />
            <Button 
              variant="contained" 
              color="secondary"
              onClick={handleCarregarDXFMultiplo}
              disabled={!dxfMultiPecasFile}
            >
              Carregar DXF Múltiplo
            </Button>
            
            {/* Controles de separação removidos: distância fixa (10) aplicada automaticamente */}
          </div>
        </PermissionGate>
      </div>

      {/* Modal de Consulta: exibe tabela fixa de numerações (19..45) conforme gradeNumeracao do backend */}
      <Modal open={openConsultaModal} onClose={() => setOpenConsultaModal(false)} disableEnforceFocus disableAutoFocus>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'min(1100px, 98vw)', maxHeight: '85vh', p: 2, overflowY: 'auto' }}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Grade de Consumo</Typography>
            <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Número</label>
                <select value={consultaNumero} onChange={(e) => setConsultaNumero(e.target.value)}>
                  <option value="">-- selecione --</option>
                  {numerosGrade.map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>Componente</label>
                <select value={consultaComponente} onChange={(e) => setConsultaComponente(e.target.value)}>
                  <option value="">-- Todos --</option>
                  {Array.from(new Set((itemsFichaTecnicaFiltra || []).map(i => i.componentes).filter(Boolean))).map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
              </div>

              <Button variant="contained" onClick={() => setConsultaTriggered(prev => !prev)} sx={{ height: 36 }}>Consultar</Button>
            </Box>

            <div style={{ overflowX: 'auto' }}>
              <table border="1" style={{ borderCollapse: 'collapse', width: '100%', minWidth: 600 }}>
                <thead>
                  <tr>
                    <th style={{ padding: '6px 8px' }}>Componente</th>
                    <th style={{ padding: '6px 8px', textAlign: 'center' }}>Número</th>
                    <th style={{ padding: '6px 8px', textAlign: 'center' }}>Consumo</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Se não houver consulta disparada, exibir mensagem orientativa
                    if (!consultaTriggered) return (<tr><td colSpan={3} style={{ padding: 12, textAlign: 'center' }}>Selecione número e componente, depois clique em Consultar</td></tr>);

                    const itensFiltrados = (itemsFichaTecnicaFiltra || []).filter(it => {
                      if (!consultaComponente) return true;
                      return String(it.componentes).toLowerCase() === String(consultaComponente).toLowerCase();
                    });

                    if (itensFiltrados.length === 0) return (<tr><td colSpan={3} style={{ padding: 12, textAlign: 'center' }}>Nenhum item encontrado para os filtros</td></tr>);

                    return itensFiltrados.map(item => {
                      const grade = getGradeNumeracao(item) || {};
                      const valor = (consultaNumero && grade && (grade[consultaNumero] !== undefined && grade[consultaNumero] !== null)) ? grade[consultaNumero] : '-';
                      return (
                        <tr key={item.id || item.codigo || item.componentes}>
                          <td style={{ padding: '6px 8px', maxWidth: 260, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.componentes || '-'}</td>
                          <td style={{ padding: '6px 8px', textAlign: 'center' }}>{consultaNumero || '-'}</td>
                          <td style={{ padding: '6px 8px', textAlign: 'center' }}>{valor}</td>
                        </tr>
                      );
                    });
                  })()}
                </tbody>
              </table>
            </div>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button variant="text" onClick={() => setOpenConsultaModal(false)}>Fechar</Button>
            </Box>
          </Paper>
        </Box>
      </Modal>

      <ItemsFichaTecnicaTabela
        vetor={itemsFichaTecnicaFiltra}
        selecionar={selecionarItemsFicha}
        custoTotal={custoTotal}
        loading={loading}
        produto={produtos}
        selectedItems={selectedItems}
        handleCheckboxChange={handleCheckboxChange}
        onDeleteSelected={remover}
        handleVerPdf={handleVerPdf}
      />
      {/* Modal de Grade */}
      <Modal open={openGradeModal} onClose={() => setOpenGradeModal(false)} disableEnforceFocus disableAutoFocus>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'min(900px, 95vw)', maxHeight: '85vh', p: 4, overflowY: 'auto' }}>
          <Paper sx={{ p: 2 }}>
            <GradeFormulario
              gradeNumeracao={gradeNumeracao}
              onChange={setGradeNumeracao}
              idProduto={idProduto}
              apiBase={_url}
              itemsList={ItemsFichaTecnicas}
              selectedItems={selectedItems}
              onEncaixeManual={(num, componente) => {
                setNumeroParaEncaixeManual(num);
                setComponenteParaEncaixeManual(componente || null);
                setShowEncaixeManual(true);
              }}
              onSaveGrade={async (num, consumo, componente, idItemFromChild) => {
                // Atualiza localmente primeiro
                setGradeNumeracao((prev) => ({ ...prev, [num]: consumo }));
                mostrarMensagem(`Grade ${num} atualizada (consumo: ${consumo})`);
                // Determina ID do item alvo (ID_ITEM): prioriza id informado pelo filho, senão objItemsFicha.id (quando válido), senão selectedItems[0]
                let idItem = null;
                if (typeof idItemFromChild !== 'undefined' && idItemFromChild !== null && idItemFromChild !== '') {
                  idItem = idItemFromChild;
                } else if (objItemsFicha && Number.isInteger(Number(objItemsFicha.id)) && Number(objItemsFicha.id) > 0) {
                  idItem = objItemsFicha.id;
                } else if (selectedItems && selectedItems.length === 1) {
                  idItem = selectedItems[0];
                }

                if (!idItem) {
                  console.warn('[Grade] idItem não encontrado. Não será feita requisição ao backend.');
                  mostrarMensagem('Selecione um item ou abra o item para editar antes de salvar no servidor');
                  return;
                }

                // Monta payload conforme especificado
                const payload = {
                  numeroGrade: String(num),
                  consumo: Number(consumo),
                };
                if (componente) payload.componente = componente;

                try {
                  const resp = await fetch(`${_url}/items-ficha-tecnica/${idItem}/grade/consumo`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` },
                    body: JSON.stringify(payload)
                  });
                  if (!resp.ok) {
                    const txt = await resp.text().catch(() => '');
                    throw new Error(`(${resp.status}) ${txt}`);
                  }
                  const data = await resp.json();
                  console.log('Resposta do backend (atualizado item):', data);
                  mostrarMensagem(`Grade ${num} salva no servidor`);
                  // Opcional: recarregar items para refletir mudanças
                  await recarregarItemsFicha();
                } catch (err) {
                  console.error('Erro ao salvar consumo da grade no backend', err);
                  mostrarMensagem('Falha ao salvar grade no servidor');
                }
              }}
              componentesOptions={Array.from(new Set(ItemsFichaTecnicas.map(i => i.componentes).filter(Boolean)))}
            />
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="text" onClick={() => setOpenGradeModal(false)}>Fechar</Button>
              {/* Aqui você pode adicionar lógica para salvar a grade se necessário */}
            </Box>
          </Paper>
        </Box>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={popperMessage}
      />

      {/* Modal de Confirmação */}
      <ConfirmationModal
        open={modalConfirm.open}
        title={modalConfirm.title}
        message={modalConfirm.message}
        type={modalConfirm.type}
        confirmText={modalConfirm.confirmText}
        cancelText={modalConfirm.cancelText}
        onConfirm={() => {
          modalConfirm.onConfirm && modalConfirm.onConfirm();
        }}
        onCancel={() => setModalConfirm(prev => ({ ...prev, open: false }))}
      />
    </div>
  );
};

export default ItemsFichaTecnica;